import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import {store} from "./../redux";
import Dashboard from "./Dashboard";
import Login from "./Login";

import DashboardAdmin from "./DashboardAdmin";
import RedirectToDashboard from "./RedirectToDashboard";
import Notification from "./Notification";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";

export default () => (
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/RedirectTo" element={<RedirectToDashboard />} />
        <Route path="/DashboardAdmin" element={<DashboardAdmin />} />
        <Route path="/Notification" element={<Notification />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/ResetPassword" element={<ResetPassword />} />
      </Routes>
    </BrowserRouter>
  </Provider>
);
